<template>
	<div class="common-layout">
		<el-container>
			<el-header>
				<topbar @isCollapseController="getCollapseStatus"></topbar>
			</el-header>
		</el-container>
		<el-container>
			<el-aside :width="menu_is_collapse?'64px':'256px'">
				<el-scrollbar>
					<sidebar :collapse="menu_is_collapse"></sidebar>
				</el-scrollbar>
			</el-aside>
			<el-container>
				<el-main>
					<router-view/>
				</el-main>
				<el-footer class="footer">
						<el-link class="copyright" type="info" target="_blank" href="http://www.thisadmin.cn">Powered by ThisAdmin ©2016-{{new Date().getFullYear()}} 版权所有 山东正则信息技术有限公司</el-link>
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>

<script>
//引入全局组件
import topbar from "@/layout/topbar"
import sidebar from "@/layout/sidebar"

export default {
  name: 'home',
  components: {topbar, sidebar},
  data() {
    return {
      menu_is_collapse: false
    }
	},
	created() {
  },
	methods:{
    getCollapseStatus(data){
			this.menu_is_collapse = data;
    }
	}
}
</script>
<style lang="less" scoped>
.el-row {margin-bottom : 20px;
  &:last-child {margin-bottom : 0;}
}
.grid-content {min-height : 36px;}
.card {border-radius : 2px;background : #fff;box-shadow : 0 1px 2px 0 rgba(0, 0, 0, .05);
  .card-header {position : relative;height : 42px;line-height : 42px;padding : 0 15px;border-bottom : 1px solid #f6f6f6;color : #333;border-radius : 2px 2px 0 0;font-size : 14px;
    .tip {position : absolute;right : 15px;height : 18px;line-height : 18px;display : inline-block;padding : 0 6px;font-size : 12px;text-align : center;background : #1e9fff;color : #fff;border-radius : 2px;}
  }
  .card-body {position : relative;padding : 15px;line-height : 24px;
    .big-num {padding : 5px 0 10px;line-height : 36px;font-size : 36px;color : #666;overflow : hidden;text-overflow : ellipsis;word-break : break-all;white-space : nowrap;}
    .tip {position : absolute;right : 15px;
      .iconfont {font-size : 16px;}
    }
  }
}
//  快捷导航
.quick-nav-card a {display : block;height : 90px;padding-top : 15px;border-radius : 2px;background : #fff;box-shadow : 0 1px 2px 0 rgba(0, 0, 0, .05);border : 1px solid #fff;text-align : center;
  .iconfont {display : block;margin-bottom : 10px;font-size : 26px;
    &.color01 {color : #329ae5;}
    &.color02 {color : #84d74c;}
    &.color03 {color : #ff9c6e;}
    &.color04 {color : #a162e4;}
    &.color05 {color : #ecc14c;}
    &.color06 {color : #4dd4cb;}
    &.color07 {color : #ee6eac;}
    &.color08 {color : #f5b55d;}
  }
  span {color : #666;}
  &:hover {border : 1px solid #eaeaea;}
}
//  表格部分
.table-card {border-radius : 2px;background : #fff;box-shadow : 0 1px 2px 0 rgba(0, 0, 0, .05);
  .cont {position : relative;padding : 10px 15px;line-height : 24px;
    table {width : 100%;margin : 5px 0;
      thead tr {background : #f2f2f2;}
      tr {transition : all 0.3s;-webkit-transition : all 0.3s;}
      th {font-weight : normal;}
      th, td {padding : 9px 15px;min-height : 20px;line-height : 20px;font-size : 14px;color : #666;border : 1px solid #e6e6e6;}
    }
  }
}
.g-title {position : relative;height : 42px;line-height : 42px;padding : 0 15px;border-bottom : 1px solid #f6f6f6;color : #333;border-radius : 2px 2px 0 0;font-size : 14px;}

.footer{
text-align: center; font-size: 12px; color: #999;background: #eee !important;
	.copyright{padding:20px;}
}
</style>
